export default "__VITE_ASSET__98963c31__"